export const Actions = {
  OPEN_MODAL: 'openModal',
  CHECK_COUPON_VALID: 'checkCouponValid',
  VALIDATE_EMAIL_TAB: 'validateEmailTab',
  TRACK_PRODUCT_ADDED: 'trackProductAdded',
  TRACK_PRODUCT_REMOVED: 'trackProductRemoved',
}
